<template>
    <div class="font-body">
        <LandingNav
            background-color="#FFFFFF"
            logo-light="/hkcm/images/logo-on-light-background.svg"
            logo-small-light="/hkcm/images/logo-small-on-light-background.svg"
            :cta-text="'Analyse-Pakete entdecken'"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            :show-ticker="true"
            ticker-text="+++ Ø<span class='font-semibold'> 70 % Trefferquote</span> über alle Analysebereiche +++ <span class='font-semibold'>Klare</span> Einstiegs-, Ausstiegs- und Risikomarken +++ <span class='font-semibold'>Strukturierte Szenarien</span> statt Bauchgefühl +++"
        />

        <!-- HERO -->
        <HeroSection
            background-color="radial-gradient(circle at 50% 50%, #072551 0%, #020E20 100%)"
            :badges="heroBadges"
            title="Analyse statt FOMO: Die wichtigsten Kryptowährungen bei HKCM"
            title-highlight="Kryptowährungen"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#3B125E"
            subtitle="Chartanalyse von Bitcoin, Ethereum und Altcoins mit Einstiegs- und Ausstiegszonen auf Basis der Elliott-Wellen-Analyse."
            :benefits="heroBenefits"
            checkmark-color="text-blue"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            price-color="text-purple"
            :social-proof-text="'<div>Bereits über 25.000</div><div>zufriedene Kunden</div>'"
            social-proof-image="/hkcm/images/rezensionenBilder.png"
            :app-store-data="appStoreData"
            :google-play-data="googlePlayData"
            background-image="/hkcm/images/bg_candels.png"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
        />

        <!-- VIDEO SECTION -->
        <VideoSection
            background-color="transparent"
            video-url="https://iframe.mediadelivery.net/embed/369702/a5d491c5-9eb7-47d4-824e-0eb9aa5feed7?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :video-height="500"
        />

        <!-- BETTER DECISIONS IN CRYPTO -->
        <ContentSection
            background-color="#FFFFFF"
            title="Bessere Entscheidungen im Kryptomarkt"
            title-highlight="Kryptomarkt"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#3B125E"
            title-color="text-blue-dark"
            :paragraphs="betterDecisionsParagraphs"
            paragraphs-length="max-w-none"
            cta-text="Krypto-Analysen jetzt bestellen"
            cta-link="/produkte"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
            :tiles="statsCards"
            :tiles-background="'bg-[#e5f0ff]'"
            :tiles-title-color="'text-[#006CFF]'"
            :tiles-description-color="'text-[#000000]'"
        />

        <!-- WHAT YOU GET IN CRYPTO PACKAGES -->
        <FeatureCardsSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Das erhalten Sie in unseren<br class='lg:block hidden'> Krypto-Paketen"
            title-highlight="Krypto-Paketen"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#8A38DC"
            title-color="text-white"
            :cards="featureCards"
            card-background-color="bg-white"
            card-title-color="text-[#000000]"
            card-text-color="text-[#000000]"
            card-icon-color="text-[#006CFF]"
            icon-size="text-[120px]"
            card-width="lg:w-[28rem] w-80"
            cta-text="Krypto-Analysen jetzt bestellen"
            cta-link="/produkte"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
        />

        <!-- CRYPTO PACKAGES SECTION -->
        <AnalysePaketeSection
            background-color="linear-gradient(135deg, #8A38DC 0%, #3B125E 100%)"
            title="Unsere Krypto-Pakete"
            title-color="text-white"
            title-highlight="Krypto-Pakete"
            title-highlight-color="text-black"
            icon-image="https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/krypto-white.png"
            subtitle="Wählen Sie das Analysepaket passend zu Ihrem Marktinteresse und Ihrer Strategie."
            subtitle-color="text-white"
            :packages="kryptoPakete"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
            icon-color="text-white"
        />

        <!-- WHY ELLIOTT WAVES FOR BTC AND ETH -->
        <VideoContentSection
            background-color="bg-white"
            title="Warum Elliot-Wellen bei BTC und ETH so<br class='hidden lg:block'> erfolgreich sind"
            title-highlight="Elliot-Wellen"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#8A38DC"
            title-color="text-blue-dark"
            content="Den perfekten Kaufzeitpunkt für Bitcoin oder Ethereum gibt es nicht, da starke Kursschwankungen präzise Ein- und Ausstiege nahezu unmöglich machen. Stattdessen kann es sinnvoll sein, bei fallenden Kursen schrittweise Positionen aufzubauen und bei steigenden Preisen gestaffelt Gewinne mitzunehmen. Die Elliott-Wellen-Analyse unterstützt dabei, weil sie wiederkehrende Marktzyklen und psychologische Muster sichtbar macht, die im Kryptomarkt besonders ausgeprägt sind."
            text-color="text-[#000000]"
            :height="500"
            position="right"
            :image="$asset('/hkcm/images/methodology2.png', 'public')"
        />

        <!-- ALTCOIN STRATEGY -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Unsere Altcoin-Analysestrategie"
            title-highlight="Altcoin-Analysestrategie"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#3B125E"
            title-color="text-white"
            content="Im volatilen Kryptomarkt führt FOMO häufig zu unüberlegten Entscheidungen. Um Anlegern Orientierung zu geben, werden Altcoins täglich und über eine breite Auswahl hinweg analysiert. Der Fokus liegt darauf, relevante Kursmarken, alternative Szenarien, markante Wendepunkte sowie konkrete Zielzonen frühzeitig zu definieren, damit fundierte Entscheidungen möglich werden."
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/0a06044e-5e8e-4e52-8eb6-57537e61b22c?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="384"
            position="left"
        />

        <!-- WHAT YOU GET SECTION -->
        <WhatYouGetSection
            title="Was Sie bei HKCM konkret erhalten und was nicht"
            title-highlight="HKCM"
            title-highlight-color="#8A38DC"
            title-color="#ffffff"
            description="Damit keine falschen Erwartungen entstehen, ist uns Transparenz wichtig: <br>HKCM ist kein Broker, keine Handelsplattform und keine Vermögensverwaltung. Sie kaufen bei uns keine Aktien und führen über uns keine Transaktionen aus. Stattdessen erhalten Sie strukturierte, methodisch abgeleitete Marktanalysen auf Basis der Elliott-Wellen-Theorie — als fundierte Entscheidungsgrundlage für Ihre eigenen Investmententscheidungen."
            description-color="#FFFFFF"
            cta-text="Krypto-Analysen jetzt bestellen"
            cta-link="/produkte"
            cta-style="px-4 py-4 mt-6 rounded-full font-bold text-md flex items-center gap-2 transition text-white hover:opacity-90 w-full justify-center lg:w-fit bg-gradient-to-r from-[#3B125E] to-[#8A38DC]"
            :image="$asset('/hkcm/images/man_lp.png', 'public')"
            image-alt="HKCM Experte"
            :show-cta="true"
        />

        <!-- WHO IS IT FOR -->
        <WhoIsItForSection
            title="Für wen unsere Analysen geeignet sind"
            title-highlight="Analysen"
            title-highlight-color="#8A38DC"
            title-color="#1a1a1a"
            intro-text="Unsere Analyse-Pakete richten sich an Anleger, die ihre Investmententscheidungen eigenständig treffen, dabei aber nicht auf Bauchgefühl oder Schlagzeilen vertrauen möchten. Die Analysen liefern Ihnen strukturierte Marktmodelle, Szenarien und Kursmarken. Sie sind als Entscheidungsgrundlage gedacht, nicht als automatisches Handelssystem. Damit Sie schnell erkennen können, ob unser Ansatz zu Ihnen passt, finden Sie hier eine klare Einordnung."
            intro-text-color="#000"
            :cards="whoIsItForCards"
            card-border-color="#e5f0ff"
            card-title-color="#000000"
            card-text-color="#000000"
            icon-color="text-[#006CFF]"
            card-background="bg-[#e5f0ff]"
        />

        <!-- IMPORTANT TO UNDERSTAND -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Wichtig zu verstehen"
            title-highlight="verstehen"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#3B125E"
            title-color="text-white"
            content="Unsere Analysen sind ein Werkzeug für strukturierte Entscheidungen, kein Ersatz für eigene Verantwortung. Je aktiver und strukturierter Sie investieren, desto größer ist der praktische Nutzen der Analysen."
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/94df397b-cedd-4ecd-9040-6cd65752f344?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="384"
            position="left"
            cta-text="Krypto-Analysen jetzt bestellen"
            cta-link="/produkte"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
        />

        <!-- HOW TO USE SECTION -->
        <HowToUseSection
            background-color="#ffffff"
            title="So nutzen Sie unsere Analysen"
            title-highlight="Analysen"
            title-highlight-color="#8A38DC"
            title-color="#1a1a1a"
            :steps="howToUseSteps"
            disclaimer="HKCM bietet Marktanalysen und Szenarien auf Basis der Elliott-Wellen-Theorie. Es erfolgt keine Anlageberatung und keine Kaufabwicklung."
            disclaimer-color="#000000"
            active-step-color="#006CFF"
            inactive-step-color="#072551"
            line-color="#072551"
            label-color="#000000"
        />

        <!-- WHO IS BEHIND HKCM -->
        <WhoIsBehindSection
            background-color="bg-[#006cff1a]"
            title="Wer hinter HKCM steht"
            title-highlight="HKCM"
            title-highlight-color="#8A38DC"
            title-color="#1a1a1a"
            intro-text="HKCM steht für strukturierte Marktanalyse statt Meinungsprognose. Unser Fokus liegt darauf, Marktbewegungen methodisch einzuordnen und daraus klare Szenarien sowie Kursmarken abzuleiten."
            intro-text-color="#000"
            :paragraphs="whoIsBehindParagraphs"
            paragraph-color="#000"
            image="/hkcm/images/team/pk.jpg"
            image-alt="Philip Klinkmüller"
            badge-top-text="Über"
            badge-main-text="70 %"
            badge-bottom-text="Trefferquote"
            :features="whoIsBehindFeatures"
            feature-title-color="text-[#006CFF]"
            feature-subtitle-color="#000"
            checkmark-color="text-[#006CFF]"
        />

        <!-- FINAL CTA -->
        <FinalCTASection
            background-color="linear-gradient(to bottom, #072551, #020E20)"
            title="Finden Sie jetzt das passende Analyse-Paket für Ihre Strategie"
            title-highlight="Analyse-Paket"
            title-highlight-gradient-from="#8A38DC"
            title-highlight-gradient-to="#3B125E"
            title-color="text-white"
            description="Alle Pakete basieren auf methodischer Marktanalyse statt Prognose — transparent und strukturiert abgeleitet."
            description-color="text-white"
            image="/hkcm/images/zugang_zum_hype_aktien_paket.png"
            image-alt="Krypto Analyse"
            image-position="left"
            cta-text="Krypto-Analysen jetzt bestellen"
            cta-link="/produkte"
            button-gradient-from="#3B125E"
            button-gradient-to="#8A38DC"
            price-color="text-purple"
        />

        <!-- FOOTER -->
        <LandingFooter
            background-color="#FFFFFF"
            logo="/hkcm/images/logo-on-light-background.svg"
            logo-link="/produkte"
            link-color="text-[#031837]"
            cta-text="Analyse-Pakete entdecken"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
        />
    </div>
</template>

<script setup>
import i18next from 'i18next';
import LandingNav from '../components/landing/LandingNav.vue';
import HeroSection from '../components/landing/HeroSection.vue';
import VideoSection from '../components/landing/VideoSection.vue';
import ContentSection from '../components/landing/ContentSection.vue';
import FeatureCardsSection from '../components/landing/FeatureCardsSection.vue';
import VideoContentSection from '../components/landing/VideoContentSection.vue';
import AnalysePaketeSection from '../components/landing/AnalysePaketeSection.vue';
import HowToUseSection from '../components/landing/HowToUseSection.vue';
import WhoIsItForSection from '../components/landing/WhoIsItForSection.vue';
import WhoIsBehindSection from '../components/landing/WhoIsBehindSection.vue';
import LandingFooter from '../components/landing/LandingFooter.vue';
import FinalCTASection from '../components/landing/FinalCTASection.vue';
import WhatYouGetSection from '../components/landing/WhatYouGetSection.vue';

// App Store data
const appStoreData = {
    link: 'https://apps.apple.com/de/app/hkcm/id6499010943',
    badge: i18next.language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png',
    rating: '4.4',
    stars: '/hkcm/images/stars4_5_yellow.png',
    reviews: '1.8k'
};

// Google Play data
const googlePlayData = {
    link: 'https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1',
    badge: i18next.language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png',
    rating: '4.5',
    stars: '/hkcm/images/stars4_5_green.png',
    reviews: '7.3k'
};

// Hero badges
const heroBadges = [
    { src: '/hkcm/images/partners/BlackBull24_Krypto_square.png', alt: 'Black Bull Award Winner' },
    { src: '/hkcm/images/partners/BlackBull25_InvestmentVision.png', alt: 'Investment Visionary Award' },
    { src: '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', alt: 'DISQ Trust', class: 'w-full object-contain max-h-[180px] lg:w-auto' }
];

// Hero benefits
const heroBenefits = [
    'Strukturierte Analysen für<br class="hidden lg:block"> Bitcoin, Ethereum & Altcoins',
    'Einstiegs- und Ausstiegszonen<br class="hidden lg:block"> auf Basis der Elliott-<br class="hidden lg:block">Wellen-Analyse',
    'Wöchentliche Zusatzanalyse<br class="hidden lg:block"> mit MACD, RSI und<br class="hidden lg:block"> Momentum-Squeeze',
    'Zubuchbare<br class="hidden lg:block"> Videoanalyse'
];

// Better Decisions paragraphs
const betterDecisionsParagraphs =
    'Viele Anleger starten im Kryptomarkt mit einem naheliegenden Ansatz. Sie verfolgen Social-Media-Trends, lesen Schlagzeilen und reagieren auf kurzfristige Kursausschläge. Das Problem ist fehlende Struktur. Einzelne News oder Hypes sagen selten, was Investoren wirklich brauchen. Nämlich zwei klare Antworten: In welche Kryptowährung investiere ich – und zu welchem Zeitpunkt.<br><br>' +
    '<strong>Ohne methodische Marktanalyse entstehen typische Fehler:</strong><br><br>' +
    '<ul style="list-style-type:disc; margin-left: 30px; margin-bottom: 10px;">' +
    '<li>Einstieg aus FOMO statt auf Basis definierter Zielzonen</li>' +
    '<li>Kein klares Szenario für Bitcoin-Dominanz oder Altcoin-Phasen</li>' +
    '<li>Orientierung an Meinungen statt an strukturierten Chartmarken</li>' +
    '<li>Reaktion auf Volatilität statt Planung mit klaren Ein- und Ausstiegszonen</li>' +
    '</ul>' +
    'Unsere Krypto-Pakete liefern strukturierte Analysen und klar definierte Kursmarken, auf Basis der Elliott-Wellen-Methodik.';

// Stats Cards
const statsCards = [
    { title: '+15', description: 'Methodik seit 15 <br> Jahren' },
    { title: '+15.000', description: 'Mehr als Analysen<br>erstellt' },
    { title: '+25.000', description: 'Mehr als<br>Nutzer' },
    { title: '+290', description: 'Durchschnittlich <br> Analysen im Monat' }
];

// Feature Cards
const featureCards = [
    {
        title: 'Klare<br>Handelsmöglichkeiten',
        icon: '/hkcm/images/icons/feature_crosshair.svg',
        content:
            'Einstiegs- und Ausstiegszonen auf Basis der Elliott-Wellen-Analyse für Bitcoin, Ethereum und führende Altcoins – per Mail, direkt in die App (inklusive Push-Benachrichtigung) oder jederzeit im HKCM-Dashboard abrufbar.'
    },
    {
        title: 'Zugang zum<br>Musterportfolio',
        icon: '/hkcm/images/icons/feature_briefcase.svg',
        content: 'Unser integriertes Musterportfolio dokumentiert alle Einstiege, Ausstiege, Nachkäufe und Stopps transparent und jederzeit nachvollziehbar.'
    },
    {
        title: 'Tägliche<br>Analyse',
        icon: '/hkcm/images/icons/feature_chartline.svg',
        content: 'Sie erhalten werktäglich schriftliche Chartanalysen zu Bitcoin und Ethereum sowie im Altcoin-Paket systematische Analysen ausgewählter Kryptowährungen.'
    },
    {
        title: 'Schnelle Reaktionen auf<br>Marktbewegungen',
        icon: '/hkcm/images/icons/feature_lightning.svg',
        content: 'Bei starken Kursbewegungen oder wichtigen Ereignissen informieren wir Sie umgehend per Kurznachricht in Ihrem Dashboard oder in der HKCM-App.'
    },
    {
        title: 'Übersichtliche<br>Chartbilder',
        icon: '/hkcm/images/icons/feature_chartbar.svg',
        content: 'Mit klar markierten Unterstützungen, Widerständen und Zielzonen erhalten Sie eine präzise Orientierung – sowohl für Long- als auch für Short-Szenarien.'
    },
    {
        title: 'Zubuchbare<br>Videoanalysen',
        icon: '/hkcm/images/icons/feature_videocamera.svg',
        content:
            'Ergänzend zu den schriftlichen Analysen können Sie regelmäßige Videoanalysen nutzen. Hier werden relevante Chartmarken eingeordnet und neue Marktstrukturen detailliert erklärt.'
    }
];

// Krypto Packages
const kryptoPakete = [
    {
        name: 'Bitcoin/Ethereum',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/bitcoin.png',
        link: '/produkte/bitcoin-ethereum',
        buttonText: 'Auswählen',
        infoText: 'Bitcoin und Ethereum Analysen'
    },
    {
        name: 'Altcoin',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/altcoin.png',
        link: '/produkte/altcoin-paket',
        buttonText: 'Auswählen',
        infoText: 'Altcoin Analysen'
    }
];

// How to Use Steps
const howToUseSteps = [
    {
        label: 'Analysepaket\nauswählen',
        iconImage: '/hkcm/images/icons/step_package.svg'
    },
    {
        label: 'Zugriff\nerhalten',
        iconImage: '/hkcm/images/icons/step_key.svg'
    },
    {
        label: 'Kursmarken &\nSzenarien einsehen',
        iconImage: '/hkcm/images/icons/step_chartline.svg'
    },
    {
        label: 'Eigene Entscheidungen\nableiten',
        iconImage: '/hkcm/images/icons/step_lightbulb.svg'
    }
];

// Who Is It For Cards
const whoIsItForCards = [
    {
        title: '… Sie Ihre Investmententscheidungen<br> selbst treffen',
        description:
            'Sie möchten nicht blind Empfehlungen folgen, sondern nachvollziehen, warum bestimmte Marktbewegungen entstehen können. Unsere Analysen zeigen Struktur, Szenarien und Entscheidungsmarken, die Umsetzung liegt bei Ihnen.',
        icon: '/hkcm/images/icons/who_brain.svg'
    },
    {
        title: '… Sie mit Kursmarken und Szenarien<br> arbeiten möchten',
        description:
            'Unsere Methodik liefert keine pauschalen „Kaufen / Verkaufen"-Aussagen. Stattdessen erhalten Sie konkrete Marktmarken und alternative Szenarien. Das ist ideal für Anleger, die strukturiert planen und Entscheidungen an klaren Bedingungen ausrichten möchten.',
        icon: '/hkcm/images/icons/who_chartlineup.svg'
    },
    {
        title: '… Sie regelmäßig Kapital in<br> Kryptowährungen investieren',
        description:
            'Die Analysepakete entfalten ihren größten Nutzen für Anleger, die fortlaufend investieren oder bestehende Positionen aktiv managen. Wenn Sie monatlich oder regelmäßig Kapital am Markt einsetzen, helfen strukturierte Marktanalysen besonders bei Timing- und Risikofragen.',
        icon: '/hkcm/images/icons/who_coins.svg'
    },
    {
        title: '… Sie Marktbewegungen besser verstehen<br> wollen',
        description:
            'Viele Nutzer schätzen unsere Analysen nicht nur wegen der Marken, sondern wegen des Marktverständnisses. Sie lernen zu erkennen, in welcher Marktphase sich ein Wert befindet, ob eine Bewegung strukturell stabil wirkt, wo Korrekturen typisch sind, wann Strukturen brechen. Das stärkt Ihre eigene Entscheidungskompetenz.',
        icon: '/hkcm/images/icons/who_lightbulb.svg'
    }
];

// Who Is Behind Section - Paragraphs
const whoIsBehindParagraphs = [
    'Unsere Analysen basieren auf der Elliott-Wellen-Theorie. Nicht, weil sie „kompliziert klingt", sondern weil sie Marktphasen und Korrekturen systematisch beschreibbar macht. Das Ziel ist nicht, den Markt perfekt vorherzusagen, sondern Ihnen ein nachvollziehbares Modell zu geben, mit dem Sie Entscheidungen strukturierter treffen können.',
    'Wir arbeiten mit einem Szenario basierten Ansatz. Das bedeutet: Sie erhalten nicht nur eine Richtung, sondern mehrere mögliche Entwicklungen, inklusive klarer Marken, ab wann ein Szenario bestätigt oder verworfen ist. So entsteht Orientierung, gerade in volatilen Marktphasen.'
];

// Who Is Behind Section - Features
const whoIsBehindFeatures = [
    {
        title: "Methodik statt<br class='hidden lg:block'> Meinung",
        subtitle: 'feste<br>Analyse-Logik'
    },
    {
        title: "Szenarien statt<br class='hidden lg:block'> Prognosen",
        subtitle: 'klar definierte<br>Bedingungen'
    },
    {
        title: "Kursmarken statt<br class='hidden lg:block'> Bauchgefühl",
        subtitle: 'transparente<br>Entscheidungszonen'
    },
    {
        title: "Regelmäßige<br class='hidden lg:block'> Updates",
        subtitle: 'Anpassungen bei<br>Marktveränderungen'
    }
];
</script>

<style scoped></style>
